import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AnonymousContentPage } from 'shared.components/anonymous-content-page/anonymous-content-page';

@Component({
  selector: 'nc-help-center',
  templateUrl: './help-center.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HelpCenterComponent extends AnonymousContentPage {

  constructor() {
    super();
  }
}
